import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLoaderData } from 'react-router-dom';
const typeLabel = {
    feature: {
        text: '新機能',
        className: 'bg-teal-100 text-teal-800'
    },
    improvement: {
        text: '改善',
        className: 'bg-blue-100 text-blue-800'
    },
    bugfix: {
        text: 'バグ修正',
        className: 'bg-orange-100 text-orange-800'
    }
};
const Section = ({ section })=>/*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("h3", {
                className: "mb-3 text-sm font-bold tracking-wide text-teal-800",
                children: [
                    "【",
                    section.heading,
                    "】"
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "space-y-4",
                children: section.blocks.map((block, blockIndex)=>/*#__PURE__*/ _jsxs("div", {
                        children: [
                            block.title && /*#__PURE__*/ _jsx("p", {
                                className: "mb-1.5 font-semibold text-gray-900",
                                children: block.title
                            }),
                            block.text && /*#__PURE__*/ _jsx("p", {
                                className: "leading-relaxed text-gray-700",
                                children: block.text
                            }),
                            block.bullets && /*#__PURE__*/ _jsx("ul", {
                                className: "space-y-2",
                                children: block.bullets.map((bullet, bulletIndex)=>/*#__PURE__*/ _jsxs("li", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-start gap-2 text-gray-700",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-teal-500"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "leading-relaxed",
                                                        children: bullet.text
                                                    })
                                                ]
                                            }),
                                            bullet.subItems && /*#__PURE__*/ _jsx("ul", {
                                                className: "mt-1 ml-5 space-y-1",
                                                children: bullet.subItems.map((subItem, subIndex)=>/*#__PURE__*/ _jsxs("li", {
                                                        className: "flex items-start gap-2 text-sm text-gray-600",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "mt-2 h-px w-2 flex-shrink-0 bg-gray-400"
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "leading-relaxed",
                                                                children: subItem
                                                            })
                                                        ]
                                                    }, subIndex))
                                            })
                                        ]
                                    }, bulletIndex))
                            })
                        ]
                    }, blockIndex))
            })
        ]
    });
const ReleaseDetail = ()=>{
    const release = useLoaderData();
    return /*#__PURE__*/ _jsx("section", {
        className: "bg-gray-50 py-16",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto max-w-2xl px-4",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "rounded-lg bg-white p-8 shadow-sm",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mb-4 flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "font-mono text-lg font-semibold text-gray-500",
                                    children: [
                                        "v",
                                        release.version
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: `rounded-full px-3 py-1 text-sm font-medium ${typeLabel[release.type].className}`,
                                    children: typeLabel[release.type].text
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("h1", {
                            className: "mb-2 text-2xl font-bold text-gray-900",
                            children: release.title
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "mb-6 text-sm text-gray-500",
                            children: release.date
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "mb-6 leading-relaxed text-gray-700",
                            children: release.summary
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "border-t border-gray-200 pt-6",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "mb-4 text-lg font-semibold text-gray-900",
                                    children: "変更内容"
                                }),
                                release.sections ? /*#__PURE__*/ _jsx("div", {
                                    className: "space-y-6",
                                    children: release.sections.map((section)=>/*#__PURE__*/ _jsx(Section, {
                                            section: section
                                        }, section.heading))
                                }) : /*#__PURE__*/ _jsx("ul", {
                                    className: "space-y-2",
                                    children: release.details?.map((detail, index)=>/*#__PURE__*/ _jsxs("li", {
                                            className: "flex items-start gap-2 text-gray-700",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-teal-500"
                                                }),
                                                detail
                                            ]
                                        }, index))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mt-8 flex justify-center gap-4",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/releases",
                            className: "inline-block rounded-full bg-gray-200 px-6 py-2 text-sm font-bold text-gray-700 transition-colors hover:bg-gray-300",
                            children: "更新履歴一覧へ"
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/",
                            className: "inline-block rounded-full bg-teal-700 px-6 py-2 text-sm font-bold text-white transition-colors hover:bg-teal-800",
                            children: "トップページへ"
                        })
                    ]
                })
            ]
        })
    });
};
export default ReleaseDetail;
